export default __webpack_public_path__ + "jquery.f4e51bd1.png";